import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ArchiveLoan } from '@common/core/models';
import { ArchiveLoansService, LoaderService } from '@common/core/services';
import { EBitfCloseEventStatus, ERoleActions } from '@common/enums';
import { IBitfCloseEvent, IBulkUpdateItemsLoanDialogData } from '@common/interfaces';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'mpa-bulk-update-items-loan-dialog',
  templateUrl: './bulk-update-items-loan-dialog.component.html',
  styleUrls: ['./bulk-update-items-loan-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class BulkUpdateItemsLoanDialogComponent implements OnInit {
  public form: UntypedFormGroup;
  eRoleActions = ERoleActions;

  constructor(
    public dialogRef: MatDialogRef<BulkUpdateItemsLoanDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogData: IBulkUpdateItemsLoanDialogData,
    private archiveLoansService: ArchiveLoansService,
    private loaderService: LoaderService
  ) {}

  ngOnInit(): void {
    this.initForm();
  }

  private initForm() {
    this.form = new UntypedFormGroup({
      note_out: new UntypedFormControl(undefined),
      note_in: new UntypedFormControl(undefined),
      date_out: new UntypedFormControl(undefined),
      date_in: new UntypedFormControl(undefined),
    });
  }

  onSave() {
    this.loaderService.show();
    const bulkItem = new ArchiveLoan(undefined, this.form.value);
    bulkItem.prepareForBulkUpdate();

    const toUpdate = this.dialogData.bulkItemsIds.map(id => {
      return this.archiveLoansService.updateItem({
        disableHideLoader: true,
        body: bulkItem,
        id,
      });
    });

    this.archiveLoansService
      .getThrottledObservables(toUpdate)
      .pipe(finalize(() => this.loaderService.hide()))
      .subscribe(() => {
        this.dialogRef.close({
          status: EBitfCloseEventStatus.OK,
        } as IBitfCloseEvent<void>);
      });
  }

  onClose() {
    this.dialogRef.close({
      status: EBitfCloseEventStatus.CANCEL,
    } as IBitfCloseEvent<void>);
  }
}
